import { useEffect } from 'react'
import { trackExperimentViewed } from '@mc/track-event'

export const EXPERIMENT_KEY = 'pen-5038_v1'

export const useTrackPen5038ExperimentViewed = () => {
  useEffect(() => {
    trackExperimentViewed(EXPERIMENT_KEY)
  }, [])
}
